import EditWorkoutPage from "@/components/WorkoutProfiles/WorkoutPages/EditWorkoutPage";
import { useWorkoutProfilesContext } from "@/hooks/useWorkoutProfilesContext";
import { useMemo } from "react";
import { useParams } from "react-router";

const EditWorkoutPagePage = () => {
  const params = useParams();
  const { getWorkoutProfile } = useWorkoutProfilesContext();
  const profileId = params.profileId || "";
  const profile = useMemo(() => getWorkoutProfile(profileId), [getWorkoutProfile, profileId]);
  const pageId = Number(params.pageId || 0);
  return <EditWorkoutPage profile={profile} pageId={pageId} />;
};

export default EditWorkoutPagePage;
